import { raiseError } from "context/error.service";

export default async function sendDiscordError(errorMessage: string) {
  const discord_url =
    "https://discord.com/api/webhooks/1463947742769451028/85ZXzx_ATHXlvleRP0S0Znhy4RPmEYZ-SaMZ5ysUEmmONroMEEMXwUVWWa7Etc6SSbAM";

  try {
    let response = await fetch(discord_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        content: errorMessage,
      }),
    });

    if (!response.ok) {
      console.error("Failed to send error to Discord:", response.statusText);
      raiseError({
        title: "Une erreur est survenue.",
        type: "Erreur d’envoi de notification vers Discord",
        reason:
          "Impossible d'envoyer l'erreur à Discord. " + response.statusText,
        solutions: [],
      });
    }
  } catch (error: any) {
    raiseError({
      title: "Une erreur est survenue.",
      type: "Erreur d’envoi de notification vers Discord",
      reason: error.message,
      solutions: [],
    });
    console.error("Error sending error to Discord:", error);
  }
}
